// extracted by mini-css-extract-plugin
export default {"divBuscar":"SearchBar_divBuscar__I+4mf","inpBuscar":"SearchBar_inpBuscar__u32kh"};